// import {useTranslation} from 'react-i18next';
import {PickSiteLanguage} from 'src/components/main/components/PickSiteLanguage';
import {useLocationDetailsContext} from 'src/context/LocationDetailsContext';

export function InitialHeader() {
    const baseUrl = process.env.REACT_APP_CLINIC_API_ENDPOINT;

    const {
        locationDataState: {location, caregiver}
    } = useLocationDetailsContext();

    const caregiverLogoUrl = location?.careGiver ? `${baseUrl}/v1/careGivers/${location?.careGiver}/logo` : '';
    const caregiverName = caregiver?.label ?? '';

    return (
        <header className='header-nav'>
            <div className='header-nav__flex'>
                {caregiverLogoUrl && <img src={caregiverLogoUrl} height='32' alt={`${caregiverName} logo`} />}
                {!caregiverLogoUrl && <h3 className='region-name'>{caregiverName}</h3>}

                <PickSiteLanguage />
            </div>
        </header>
    );
}
